import { render, staticRenderFns } from "./Shitang13.vue?vue&type=template&id=1f3b8093&scoped=true"
import script from "./Shitang13.vue?vue&type=script&lang=js"
export * from "./Shitang13.vue?vue&type=script&lang=js"
import style0 from "./Shitang13.vue?vue&type=style&index=0&id=1f3b8093&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b8093",
  null
  
)

export default component.exports